import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetCenterStaticItems = (sameCaseGuid: string | undefined) => {
    return useQuery({
        queryKey: ['get-center-static-items'],
        queryFn: async () => {
            if (!sameCaseGuid) {
                return;
            }
            
            const response = await _apiClient.getCenterStaticItems(sameCaseGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve center static items.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!sameCaseGuid,
    });
};